// eslint-disable
import Vue from 'vue'
import axios from 'axios'
import { AppUtil } from './AppUtil'
import { EnvUtil } from './EnvUtil'
import { ThorWeblog } from '@gkid/thor'
import { StringUtil } from './StringUtil'

const sender = {
  async send(data: any) {
    const result = await axios.post('https://api.tiantiantiaosheng.com/api/ext/client_log', data, {
      headers: { Authorization: 'clientlog' },
    })
    return result.status === 200
  },
}

export class Logger extends ThorWeblog {
  constructor(siteName: string) {
    super(window, sender, siteName, {
      NODE_ENV: process.env.VUE_APP_ENV || process.env.PUB_ENV,
    })
  }

  async log(
    eventName: string,
    triggerName?: string,
    namespace?: string,
    teacherId?: string,
    eventId?: string,
    eventStep?: string
  ) {
    // 默认带上 gkidno 作为 user_id 的key
    // 默认会带上 G_event_namespace 作为 页面名称
    // G_event, G_event_trigger 传递进来的参数
    // 其他可用
    // G_event_id, G_event_step, G_event_content 等
    try {
      if (EnvUtil.isCampus()) {
        this.appendDefaultParam('gkidno', teacherId)
      }

      this.appendDefaultParam('G_event_namespace', namespace) // 固定作为页面

      const eventContent = { id: eventId, step: eventStep }
      this.trigger(eventName, triggerName, eventContent)
    } catch {
      return
    }
  }
}

export class LoggerUtil {
  public static log(message: any, ...rest: any[]) {
    // eslint-disable-next-line
    console.log(message, ...rest)
  }

  public static warn(message: any, ...rest: any[]) {
    // eslint-disable-next-line
    console.warn(message, ...rest)
  }

  public static error(message: any, ...rest: any[]) {
    // eslint-disable-next-line
    console.error(message, ...rest)
  }
}

export function codelessTrackingImg(_e: Event, _logger: typeof BaseLogger, _vue: Vue) {
  try {
    const target = _e.target as HTMLImageElement
    if (target?.tagName?.toLocaleLowerCase() === 'img') {
      _logger.event(_vue.$route.name!, 'click', target.alt || target.src)
      return true
    }
  } catch (e) {
    // noop
  }
}

export function codelessTrackingButton(_e: Event, _logger: typeof BaseLogger, _vue: Vue) {
  try {
    const target = _e.target as HTMLButtonElement
    if (target?.tagName?.toLowerCase() === 'button') {
      _logger.event(_vue.$route.name!, 'click', target.textContent || target.className)
      return true
    }
  } catch (e) {
    // noop
  }
}

export class BaseLogger {
  public static userIdKey = BaseLogger.buildUserIdKey()

  public static unionIdKey = '__logger_union_id_key__'

  public static async init() {
    if (await AppUtil.isUnderApp()) {
      try {
        this.setUserId((await AppUtil.getUserData()).user_id)
      } catch (e) {
        // noop
      }
    }
  }

  public static event(_category: string, _action: string, _label?: string, _value?: number) {}

  public static getUserId() {
    let userId = localStorage.getItem(this.userIdKey)

    if (!userId) {
      userId = StringUtil.buildUuid()
      this.setUserId(userId)
    }

    return userId
  }

  public static setUserId(_userId: string) {
    localStorage.setItem(this.userIdKey, _userId)
  }

  public static getUnionId() {
    let unionId = localStorage.getItem(this.unionIdKey)

    if (!unionId) {
      unionId = StringUtil.buildUuid()
      this.setUnionId(unionId)
    }

    return unionId
  }

  public static setUnionId(_unionId: string) {
    localStorage.setItem(this.unionIdKey, _unionId)
  }

  public static buildURL(_url: string) {
    let url = _url

    if (!_url?.startsWith('/')) {
      url = this.buildURLFromEvent(_url)
    }

    return url
  }

  public static buildUserIdKey() {
    return `__${EnvUtil.appName()}_logger_user_id_key__`
  }

  public static buildURLFromEvent(_event: string) {
    return `/__custom_event__/${_event}`
  }

  public static installCodelessTracking(_vue: Vue) {
    window.addEventListener(
      'click',
      (e) => {
        codelessTrackingImg(e, this, _vue) || codelessTrackingButton(e, this, _vue)
      },
      { capture: true, passive: true }
    )
  }
}

export class BDTJLogger extends BaseLogger {
  public static _logger = (window as any)._hmt || []

  public static event(_category: string, _action: string, _label?: string, _value?: number) {
    this._logger.push(['_trackEvent', _category, _action, _label, _value])
  }

  public static pageview(_url: string) {
    this._logger.push(['_trackPageview', this.buildURL(_url)])
  }
}

export class ARMSLogger extends BaseLogger {
  public static __logger = (window as any).__bl || {}

  public static event(_category: string, _action: string, _label?: string, _value?: number): void {
    const keys = []

    if (_category) {
      keys.push(_category)
    }
    if (_action) {
      keys.push(_action)
    }
    if (_label) {
      keys.push(_label)
    }

    this.__logger.sum(keys.join('_'), _value)
  }

  public static pageview(_url: string) {
    this.__logger.sum(this.buildURL(_url))
  }
}

export class TTTSLogger extends BaseLogger {
  public static _log(_category: string, _action: string, _label?: string, _value?: number, _meta?: any) {
    let url = ''

    if (EnvUtil.isProd()) {
      url = 'https://client-log.tiantiantiaosheng.com/log'
    } else {
      url = 'https://client-log.tiantiantiaosheng.com/log'
    }

    const body = {
      env: process.env.VUE_APP_ENV,
      app: EnvUtil.appName(),
      url: location.href,
      date: new Date().getTime(),
      agent: navigator.userAgent,
      userId: this.getUserId(),
      unionId: this.getUnionId(),
      // event
      category: 'webClientLog',
      eventCategory: _category,
      action: _action,
      label: _label,
      value: _value,
      meta: _meta,
    }

    return navigator.sendBeacon?.(url, JSON.stringify(body)) || axios.post(url, body)
  }

  public static event(_category: string, _action: string, _label?: string, _value?: number, _meta?: any): void {
    this._log(_category, _action, _label, _value, _meta)
  }

  public static pageview(_url: string, _meta?: any) {
    this._log('nav', 'click', this.buildURL(_url), undefined, _meta)
  }
}

export const logger = TTTSLogger
